import {
  StockLocationSchemaLite,
  WorkstationType,
} from 'types/clientV2/stockLocations';

export type WarehouseDeviceSettings = {
  printer3020: string | null;
  printer4020: string | null;
  printer6040: string | null;
  printer8511: string | null;
  printer2212: string | null;
  wedgeScan: boolean;
  cameraScan: boolean;
  pickingLocation: string | null;
  facility: string | null;
  sandboxMode: boolean;
  cameraName: string | null;
  autoRefreshDashboard: boolean;
  showShipDashboard: boolean;
  showReceiveDashboard: boolean;
  showHandlingDashboard: boolean;
  showCounter: boolean;
  counterSerialPort: SerialPort | null;
  currentWorkstation: StockLocationSchemaLite | null;
  workstationType: WorkstationType | null;
  beevisionIp: string | null;
  useBrowserPrint: boolean;
  useTeams: boolean;
};

export const warehouseStorageName = 'cofactr-mobile-inventory-settings';

export const warehouseDefaults = {
  printer3020: null,
  printer4020: null,
  printer6040: null,
  printer8511: null,
  printer2212: null,
  wedgeScan: true,
  cameraScan: false,
  pickingLocation: null,
  facility: null,
  sandboxMode: false,
  cameraName: '',
  autoRefreshDashboard: false,
  showShipDashboard: true,
  showReceiveDashboard: true,
  showHandlingDashboard: true,
  showCounter: false,
  counterSerialPort: null,
  currentWorkstation: null,
  workstationType: null,
  beevisionIp: null,
  useBrowserPrint: false,
  useTeams: false,
} as WarehouseDeviceSettings;
